module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/designations/designation-grid/designation-grid.component.css
// module id = ./src/app/master/designations/designation-grid/designation-grid.component.css
// module chunks = main